import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Input,
  Button,
  message,
  Spin,
  Grid,
  List,
  Tooltip,
  Tag,
  Alert,
} from "antd";

import { createSearchParams, useNavigate } from "react-router-dom";
import InfiniteScroll from "../../../src/react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModal from "./modal/confirmationModal";
import AiDrawer from "./modal/DrawerAi";
import DecisionModal from "./modal/decisionModal";
import {
  allDiaries,
  archiveModalOpen,
  arciveDiaries,
  currentDiaryDetail,
  currentDiaryTopic,
  diaryEntries,
  diaryStatus,
  entriesLoader,
  fetchDiaryEntries,
  fetchDiaryEntriesForward,
  getDiaryStatus,
  hasMore,
  hasMoreForward,
  newMessage,
  saveAllDiaries,
  saveCurrentDiary,
  saveCurrentDiaryDetail,
  saveDiaryEntries,
  saveDiaryStatus,
  saveEntriesLoader,
  saveFromSearchFlag,
  saveHasMoreEntries,
  saveHasMoreForwardEntries,
  saveHideClassName,
  saveNewArchivedDiary,
  saveNewMessage,
  saveNewlyCreatedDiary,
  saveOneDiaryEntry,
  saveScrollLoaderForward,
  saveTopEntryId,
  scrollLoader,
  scrollLoaderForward,
  searchedFlag,
  searhcedId,
  topEntryId,
  totalRecord,
  unArchiveModalOpen,
} from "redux/diaries/diariesSlice";
import moment from "moment";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import User from "models/user/user";
import {
  calculateTimeRemaining,
  convertToPlanDate,
  convertoUSFormat,
  downloadEvent,
} from "utilities/generalUtility";
import { EntryClassifier } from "utilities/enums";
import { useInView } from "react-intersection-observer";
import { InView } from "react-intersection-observer";
import {
  InfoCircleTwoTone,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

import { globalSettings } from "redux/settings/settingSlice";
import { userDetails } from "redux/roles/userRoleSlice";
import ArchiveRequest from "./modal/archiveRequest";
import ArchiveConversation from "./modal/archiveConversation";

const { TextArea } = Input;

export default function ResolveitChat() {
  const [open, setOpen] = useState(false);
  const [openDrawer, setDrawer] = useState(false);

  const showChatDrawer = () => {
    setDrawer(true);
  };
  const closeChatDrawer = () => {
    setDrawer(false);
  };

  const { useBreakpoint } = Grid;

  const screens = useBreakpoint();
  const viewportWidth = window.innerWidth;

  const options = {
    root: document.querySelector(".card-scroll"),
    rootMargin: "0px",
    threshold: 1.0,
  };
  const { ref } = useInView(options);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useState
  const [journalText, setjournalText] = useState("");
  const [btnLoading, setbtnLoading] = useState(false);
  const [relationshipStatus, setRelationshipStatus] = useState(null);
  const [isEntryModalOpen, setisEntryModalOpen] = useState(false);

  const [skipValue, setSkipValue] = useState(true);
  const [draftedEntryId, setdraftedEntryId] = useState(null);
  const [debounce, setdebounce] = useState();
  const [minutes, setMinutes] = useState(null);
  const [seconds, setSeconds] = useState(null);
  const [buttonStatus, setButtonStatus] = useState(false);
  const [acceptBtnLoading, setAcceptBtnLoading] = useState(false);
  const [declineBtnLoading, setDeclineBtnLoading] = useState(false);

  // useSelector
  const selected = useSelector(currentDiaryTopic);
  const currStatus = useSelector(diaryStatus);
  const DiaryEntries = useSelector(diaryEntries);
  const diaries = useSelector(allDiaries);
  const archiveDiaries = useSelector(arciveDiaries);
  const hasMoreEntries = useSelector(hasMore);
  const loading = useSelector(entriesLoader);
  const searchFlag = useSelector(searchedFlag);
  const searchedEntryId = useSelector(searhcedId);
  const scrollLoad = useSelector(scrollLoader);
  const diaryDetail = useSelector(currentDiaryDetail);
  const totalEntryRecord = useSelector(totalRecord);
  const forwardScrollLoad = useSelector(scrollLoaderForward);
  const hasMoreForwardEntries = useSelector(hasMoreForward);
  const settings = useSelector(globalSettings);
  const topId = useSelector(topEntryId);
  const newMessageId = useSelector(newMessage);
  const userData = useSelector(userDetails);

  // useRef
  const scrollableDivRef = useRef(null);
  const inputRef = useRef(null);
  const resolveResponseRef = useRef(null);
  const sendRevised = useRef(false);
  const draftTyping = useRef(false);

  //Modal Opener States
  const archiveModalOpener = useSelector(archiveModalOpen);
  const unArchiveModalOpener = useSelector(unArchiveModalOpen);

  // Functions

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const getDiaryEntries = (firstCall = false, fromInfinite = false) => {
    try {
      fromInfinite && dispatch(saveFromSearchFlag(false));
      firstCall && selected?.diaryId && dispatch(saveEntriesLoader(true));
      const body = {
        pageNumber: 0,
        pageSize: 10,
        searchType: 1,
        diaryId: selected?.diaryId,
        diaryTopicIds: [selected?.topicId],
        diaryEntryId: null,
        releasedEntryId: firstCall ? null : DiaryEntries[0].releasedEntryId,
        direction: firstCall ? null : 2,
      };
      if (DiaryEntries?.length <= totalEntryRecord) {
        selected?.diaryId &&
          dispatch(fetchDiaryEntries(body, firstCall ? false : true));
      } else {
        dispatch(saveHasMoreEntries(false));
      }
      currStatus?.diary?.status?.id === 1 &&
        setTimeout(() => {
          inputRef?.current?.focus();
        }, 700);
    } catch (error) {}
  };

  const getResolved = async () => {
    try {
      downloadEvent("ResolvedEntry");

      resolveResponseRef.current = null;
      if (journalText.trim()?.length > 0) {
        setbtnLoading(true);

        const body = {
          diaryEntry: journalText?.trim(),
          diaryTopicId: selected?.topicId,
        };

        const res = await NetworkCall.fetch(
          Request.getMessageResolved(body),
          false
        );

        setbtnLoading(false);
        resolveResponseRef.current = res["data"];
        if (
          res["data"]?.is_revised == false &&
          res["data"]?.input_class === EntryClassifier.SALUTATION
        ) {
          await postJournal();
        } else {
          showChatDrawer();
        }
      }
    } catch (err) {
      resolveResponseRef.current = null;
      setbtnLoading(false);
      message?.error(err?.message);
      err?.statusCode === 409 &&
        setTimeout(() => {
          window.location.reload();
        }, 3000);
    }
  };

  const editJournalText = (entry) => {
    setjournalText(entry);
    closeChatDrawer();
  };

  const postJournal = async () => {
    try {
      let entry;
      let body;
      const currTimeStamp = Math.floor(Date.now() / 1000);
      if (settings?.EnableAI === "1") {
        const resolveResponse = resolveResponseRef.current;
        entry = sendRevised.current
          ? resolveResponse?.revised_message
          : resolveResponse?.original_message;
        body = {
          text: entry,
          diaryTopicId: selected?.topicId,
          diaryId: selected?.diaryId,
          isReleased: true,
          diaryEntryId: draftedEntryId,
          diaryRelationshipId: relationshipStatus
            ? relationshipStatus?.toString()
            : null,
          connotations: resolveResponse?.connotations
            ? resolveResponse?.connotations
            : [],
          overallImpact: resolveResponse?.overall_impact,
          isRevised: sendRevised.current,
          inputClass: resolveResponse?.input_class,
          declinedEntry: sendRevised.current
            ? resolveResponse?.original_message
            : resolveResponse?.revised_message,
          timestamp: currTimeStamp,
        };
      } else {
        entry = journalText;
        body = {
          text: entry,
          diaryTopicId: selected?.topicId,
          diaryId: selected?.diaryId,
          isReleased: true,
          diaryEntryId: draftedEntryId,
          diaryRelationshipId: relationshipStatus
            ? relationshipStatus?.toString()
            : null,
          isRevised: false,
          timestamp: currTimeStamp,
        };
      }

      if (entry?.length > 0) {
        setbtnLoading(true);

        const res = await NetworkCall.fetch(Request.addEntry(body), false);
        dispatch(saveTopEntryId(null));

        dispatch(saveOneDiaryEntry(res?.data?.entry));
        setdraftedEntryId(null);
        updateDraftCount(false);

        setjournalText("");

        setbtnLoading(false);
        resolveResponseRef.current = null;
        let diary = { ...diaryDetail };
        const topicIndex = diaryDetail?.topics.findIndex((e) =>
          e.diaryTopicId
            ? e.diaryTopicId === selected?.topicId
            : e.id === selected?.topicId
        );
        const diaryTopic = [...diary.topics];
        diaryTopic[topicIndex] = {
          ...diaryTopic[topicIndex],
          lastEntrySenderId: User.getUserId(),
          lastEntryTimestamp: currTimeStamp,
          numberOfDrafts: 0,
        };
        diary = { ...diary, topics: [...diaryTopic] };
        dispatch(saveCurrentDiaryDetail(diary));

        const temp = [...diaries];
        const index = temp?.findIndex((e) => e?.diaryId === selected?.diaryId);
        const tempTopics = [...temp[index]?.topics];

        const diaryTopicIndex = tempTopics.findIndex(
          (e) => e?.id === selected?.topicId
        );
        tempTopics[diaryTopicIndex] = {
          ...tempTopics[diaryTopicIndex],
          lastEntrySenderId: User.getUserId(),
          lastEntryTimestamp: currTimeStamp,
          numberOfDrafts: 0,
        };
        temp[index] = {
          ...temp[index],
          topics: [...tempTopics],
        };
        dispatch(saveDiaryStatus({ diary: temp[index] }));

        //this will shift the most recent to the top
        const [movedObject] = temp.splice(index, 1);
        temp.unshift(movedObject);
        dispatch(saveAllDiaries(temp));

        setisEntryModalOpen(false);
        setRelationshipStatus(null);
        sendRevised.current = false;
        setTimeout(() => {
          inputRef?.current?.focus();
        }, 700);
      }
      closeChatDrawer();
      onClose();
    } catch (error) {
      sendRevised.current = false;
      setbtnLoading(false);
      message.error(error?.message);
      onClose();
      error?.statusCode === 409 &&
        setTimeout(() => {
          window.location.reload();
        }, 3000);
    }
  };

  const relationModalDecision = () => {
    if ((totalEntryRecord + 1) % 3 === 0) {
      setisEntryModalOpen(true);
    } else {
      postJournal();
    }
  };

  //Save Draft
  const draftMessage = async () => {
    try {
      if (journalText.length > 0) {
        const body = {
          text: journalText,
          diaryTopicId: selected?.topicId,
          diaryId: selected?.diaryId,
          isReleased: false,
          diaryEntryId: draftedEntryId,
          timestamp: Math.floor(Date.now() / 1000),
          isRevised: false,
        };

        const res = await NetworkCall.fetch(Request.addEntry(body), false);
        setdraftedEntryId(res?.data?.entry?.diaryEntryId);
        updateDraftCount(true);
      } else {
        if (draftedEntryId) {
          const res = await NetworkCall.fetch(
            Request.deleteEntry(draftedEntryId),
            false
          );
          updateDraftCount(false);
          setdraftedEntryId(null);
        }
      }
    } catch (error) {}
  };

  const updateDraftCount = (num) => {
    const temp = [...diaries];
    const index = temp?.findIndex((e) => e?.diaryId === selected?.diaryId);
    const tempTopics = [...temp[index]?.topics];

    const topicIndex = tempTopics.findIndex((e) => e?.id === selected?.topicId);
    tempTopics[topicIndex] = {
      ...tempTopics[topicIndex],
      numberOfDrafts: num ? tempTopics[topicIndex]?.numberOfDrafts + 1 : 0,
    };
    temp[index] = {
      ...temp[index],
      topics: [...tempTopics],
    };
    dispatch(saveDiaryStatus({ diary: temp[index] }));
    dispatch(saveAllDiaries(temp));
  };

  const getDraftMessage = async () => {
    try {
      const response = await NetworkCall.fetch(
        Request.getDraftedEntries(selected?.topicId),
        false
      );

      const newData = response?.data?.tableListing[0];
      setjournalText(newData ? newData?.text : "");
      setdraftedEntryId(newData ? newData?.diaryEntryId : null);
    } catch (error) {}
  };

  const onChange = (e) => {
    setRelationshipStatus(e?.target?.value);
  };

  const handleBiDirectionalApiCall = async (inView) => {
    dispatch(saveScrollLoaderForward(true));
    if (inView) {
      // setIsLoading(true);
      const body = {
        pageNumber: 0,
        pageSize: 10,
        diaryId: selected?.diaryId,
        diaryTopicIds: [selected?.topicId],
        searchType: 1,
        diaryEntryId: null,
        releasedEntryId: DiaryEntries[DiaryEntries.length - 1]?.releasedEntryId,
        direction: 1,
      };
      dispatch(fetchDiaryEntriesForward(body));
    }
  };

  const lockStatus = () => {
    if (currStatus?.diary?.topics) {
      const topics = currStatus?.diary?.topics.find((e) =>
        e.diaryTopicId
          ? e.diaryTopicId === selected?.topicId
          : e.id === selected?.topicId
      );

      if (!topics || topics?.lastEntryTimestamp === null) {
        setButtonStatus(false);
        seconds !== null && setSeconds(null);
        minutes !== null && setMinutes(null);
      } else {
        if (
          calculateTimeRemaining(
            topics?.lastEntryTimestamp,
            parseInt(settings?.LockPeriod)
          ) === null
        ) {
          setButtonStatus(false);
          seconds !== null && setSeconds(null);
          minutes !== null && setMinutes(null);
        } else {
          if (
            calculateTimeRemaining(
              topics?.lastEntryTimestamp,
              parseInt(settings?.GracePeriod)
            ) === null
          ) {
            if (topics?.lastEntrySenderId === User.getUserId()) {
              setButtonStatus(true);
              seconds !== null && setSeconds(null);
              minutes !== null && setMinutes(null);
            } else {
              setButtonStatus(false);
              seconds !== null && setSeconds(null);
              minutes !== null && setMinutes(null);
            }
          } else {
            if (topics?.lastEntrySenderId === User.getUserId()) {
              setButtonStatus(true);
            } else {
              let timer = calculateTimeRemaining(
                topics?.lastEntryTimestamp,
                parseInt(settings?.GracePeriod)
              );
              setSeconds(timer?.seconds);
              setMinutes(timer?.minutes);

              setButtonStatus(true);
            }
          }
        }
      }
    }
  };
  const handleDiaryStatus = async (status, action, btnNo) => {
    try {
      status === (action ? "Accepted" : "Archived")
        ? setAcceptBtnLoading(true)
        : setDeclineBtnLoading(true);
      const body = {
        diaryId: currStatus?.diary.diaryId,
        status,
      };
      const response = await NetworkCall.fetch(
        Request.UpdateInvite(body),
        false
      );
      message.success(response?.message);
      let temp = [...diaries];
      const index = temp?.findIndex(
        (e) => e?.diaryId === currStatus?.diary.diaryId
      );
      temp[index] = {
        ...temp[index],
        isArchiveOrUnarchiveRequester:
          status === "Accepted"
            ? null
            : temp[index]?.isArchiveOrUnarchiveRequester,
        status: {
          ...temp[index]?.status,
          id: status === "Accepted" ? 1 : 5,
          name: status,
        },
      };
      dispatch(saveDiaryStatus({ diary: temp[index] }));
      if (status === "Archived") {
        const x = temp.splice(index, 1);
        dispatch(saveNewArchivedDiary(x[0]));
      }
      dispatch(saveAllDiaries(temp));
      setAcceptBtnLoading(false);
      setDeclineBtnLoading(false);
      if (btnNo === 1) {
        if (currStatus?.diary?.status?.id === 6) {
          navigate("/journal-request");
          dispatch(saveDiaryStatus({}));
          dispatch(saveCurrentDiary({}));
        }
      } else if (btnNo === 2) {
        if (currStatus?.diary?.status?.id === 7) {
          navigate("/journal-request");
          dispatch(saveDiaryStatus({}));
          dispatch(saveCurrentDiary({}));
        }
      }
    } catch (error) {
      message.error(error?.message);
      setAcceptBtnLoading(false);
      setDeclineBtnLoading(false);
    }
  };

  // UseEffects

  // This render on every topic selection
  useEffect(() => {
    draftTyping.current = false;
    selected?.topicId && getDraftMessage();
    !searchFlag && dispatch(saveDiaryEntries({ data: [], append: false }));
    !searchFlag && getDiaryEntries(true);
    searchFlag && setSkipValue(false);
    resolveResponseRef.current = null;
    setMinutes(null);
    setSeconds(null);
    setButtonStatus(false);
    dispatch(saveTopEntryId(null));
    lockStatus();
  }, [selected]);

  // This render when the diary changes
  useEffect(() => {
    currStatus?.diary?.diaryId &&
      diaryDetail?.diaryId !== currStatus?.diary?.diaryId &&
      dispatch(
        getDiaryStatus(
          createSearchParams({
            diaryId: currStatus?.diary?.diaryId,
          }).toString()
        )
      );
    lockStatus();
  }, [currStatus]);

  // UI

  const [getAlertHeight, setAlertHeight] = useState(0);
  const observedDiv = useRef(null);
  useEffect(() => {
    if (!observedDiv.current) {
      setAlertHeight(0);
      return;
    }
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        // Check if the observed element is visible before updating the height
        if (entry.target.offsetWidth > 0 || entry.target.offsetHeight > 0) {
          setAlertHeight(entry.target.offsetHeight);
        } else {
          setAlertHeight(0);
        }
      });
    });
    resizeObserver.observe(observedDiv.current);

    return function cleanup() {
      resizeObserver.disconnect();
    };
  }, [observedDiv.current, selected]);

  // Serching redirection

  useEffect(() => {
    if (searchFlag && DiaryEntries.length > 0) {
      const commentElement = document.getElementById(
        `entry-${searchedEntryId}`
      );
      if (commentElement && scrollableDivRef.current) {
        commentElement.scrollIntoView({
          block: "center",
          inline: "nearest",
        });

        commentElement.classList.add("highlighted");
      }
      dispatch(saveFromSearchFlag(false));
    } else if (topId && skipValue) {
      const commentElement = document.getElementById(`entry-${topId}`);
      if (commentElement && scrollableDivRef.current) {
        commentElement.scrollIntoView({
          block: "end",
          inline: "nearest",
        });
      }
      dispatch(saveTopEntryId(DiaryEntries[0]?.diaryEntryId));
    } else if (topId === null && DiaryEntries.length > 0) {
      dispatch(saveTopEntryId(DiaryEntries[0]?.diaryEntryId));
    }
  }, [DiaryEntries]);

  // Debouncing

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setdebounce(journalText);
    }, 1000);
    return () => {
      clearTimeout(debounceTimer);
    };
  }, [journalText]);

  useEffect(() => {
    // if (debounce && debounce !== "") {
    draftTyping.current && draftMessage(debounce);
    // }
  }, [debounce]);

  // set focus

  useEffect(() => {
    inputRef?.current && inputRef?.current?.focus();
  }, [draftedEntryId, journalText]);

  // counter timer

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          setMinutes(null);
          setSeconds(null);
          setButtonStatus(false);
          lockStatus();
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    if (newMessageId) {
      setTimeout(() => {
        dispatch(saveNewMessage(null));
      }, 5000);
    }
  }, [newMessageId]);

  const OtherPersonName = `${
    diaryDetail && diaryDetail.users && diaryDetail?.users?.length > 0
      ? diaryDetail?.users[0]?.userId === User.getUserId()
        ? diaryDetail?.users[1]?.userName?.split(" ")[0]
        : diaryDetail?.users[0]?.userName?.split(" ")[0]
      : ""
  }`;

  return (
    <>
      <>
        {userData?.subscriptionStatus === "trialing" && (
          <Alert
            className="chat-alert warning journal-req-alert"
            icon={<InfoCircleTwoTone twoToneColor="#CC8406" />}
            description={
              <>
                {`Your trial period will expire on ${convertToPlanDate(
                  moment,
                  userData?.subscriptionExpiryDate
                )}`}
              </>
            }
            type="warning"
            showIcon
          />
        )}

        <div className="notebook-chat">
          <div className="encrypted-text">
            <InfoCircleOutlined />
            Your journals are secured end-to-end, ensuring that no one from
            outside can access them.
          </div>
          <div className="btn-back">
            <Button
              icon={<i className="icon-left-long-arrow"></i>}
              type="text"
              onClick={() => {
                dispatch(saveHideClassName(""));
              }}
            >
              Back
            </Button>
          </div>
          <div className="notebook-chat-wrapper position-relative">
            {newMessageId && (
              <Tag
                className="new-entry-tag"
                closeIcon={<CloseCircleOutlined />}
              >
                New Entry Received
              </Tag>
            )}

            <Card
              className={
                userData?.subscriptionStatus === "trialing" ? "alert" : ""
              }
            >
              {!loading ? (
                <>
                  {" "}
                  {scrollLoad && (
                    <Spin className="resolveit-spinner" size="small" />
                  )}
                  <div
                    ref={scrollableDivRef}
                    id="scrollableDiv"
                    style={{
                      position: "relative",
                      overflow: "auto",
                      display: "flex",
                      flexDirection: "column-reverse",
                    }}
                  >
                    <InfiniteScroll
                      className="scroll-transparent"
                      dataLength={DiaryEntries.length}
                      next={() => {
                        getDiaryEntries(false, true);
                      }}
                      hasMore={false}
                      scrollableTarget="scrollableDiv"
                      inverse={true}
                      reverse
                      height={300}
                      style={{
                        display: "flex",
                        flexDirection: "column-reverse",
                        height: `calc(100vh - ${
                          userData?.subscriptionStatus === "trialing"
                            ? "48px"
                            : "0px"
                        } - ${
                          viewportWidth >= 998
                            ? "235px"
                            : viewportWidth < 998 && viewportWidth >= 712
                            ? "283px"
                            : viewportWidth < 712 && viewportWidth >= 412
                            ? "327px"
                            : "375px"
                        }`,
                      }}
                    >
                      <>
                        <div
                          style={{
                            height: `calc(100vh - ${getAlertHeight}px - 192px)`,
                          }}
                        ></div>
                        <div ref={observedDiv}>
                          <div className="list-wrapper">
                            <List
                              className="notebook-chat-list"
                              itemLayout="vertical"
                              size="large"
                            >
                              <InView
                                rootMargin="20px"
                                skip={false}
                                onChange={(inView, entry) => {
                                  inView &&
                                    hasMoreEntries &&
                                    getDiaryEntries(false, true);
                                }}
                              >
                                <div
                                  ref={ref}
                                  id="bottom"
                                  style={{ visibility: "hidden" }}
                                >
                                  {/* <h1>{`Header inside viewport .`}</h1> */}
                                </div>
                              </InView>
                              {DiaryEntries.map((element, index) => {
                                let formattedText = element?.text.replace(
                                  /\n/g,
                                  "<br />"
                                );

                                return (
                                  <List.Item
                                    id={`entry-${element.diaryEntryId}`}
                                  >
                                    <List.Item.Meta
                                      description={
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: formattedText,
                                          }}
                                        />
                                      }
                                    />

                                    <span className="date-time">
                                      {`${convertoUSFormat(
                                        moment,
                                        element?.createdAt
                                      )} from ${element?.user?.firstName} ${
                                        element?.user?.lastName
                                      }
                                    `}
                                    </span>
                                  </List.Item>
                                );
                              })}
                            </List>
                          </div>
                          <InView
                            rootMargin="20px"
                            skip={false}
                            onChange={(inView, entry) => {
                              inView &&
                                hasMoreForwardEntries &&
                                handleBiDirectionalApiCall(inView, "");
                            }}
                          >
                            <div
                              ref={ref}
                              id="bottom"
                              style={{ visibility: "hidden" }}
                            >
                              {/* <h1>{`Header inside viewport ${skipValue}.`}</h1> */}
                            </div>
                          </InView>
                          {!hasMoreForwardEntries && (
                            <>
                              <TextArea
                                ref={inputRef}
                                placeholder="Type your Journal entry here. . ."
                                className={`note-book ${
                                  currStatus?.diary?.status?.id === 1
                                    ? ""
                                    : "disabled-text"
                                }`}
                                autoSize={true}
                                maxLength={2000}
                                onChange={(e) => {
                                  draftTyping.current = true;
                                  setjournalText(e.target.value);
                                }}
                                value={journalText}
                              />
                            </>
                          )}
                          {journalText.length > 1900 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >{`${journalText.length}/2000`}</div>
                          )}
                        </div>
                      </>
                    </InfiniteScroll>
                  </div>
                  {forwardScrollLoad && (
                    <Spin
                      spinning={forwardScrollLoad}
                      className="bottom-loading"
                    />
                  )}{" "}
                </>
              ) : (
                <Spin></Spin>
              )}
              {hasMoreForwardEntries && (
                <Button
                  className="floating-icon-down"
                  type="text"
                  size="large"
                  icon={<i className="icon-circle-down-arrow" />}
                  onClick={() => {
                    dispatch(saveHasMoreForwardEntries(false));
                    getDiaryEntries(true);
                  }}
                ></Button>
              )}
            </Card>

            {currStatus?.diary?.status?.id === 6 ||
            currStatus?.diary?.status?.id === 7 ? (
              <div
                className={`notebook-chat-footer ${
                  !currStatus?.diary?.isArchiveOrUnarchiveRequester
                    ? ""
                    : "footer-btn-start"
                }`}
              >
                <div className="nc-footer-text">
                  <InfoCircleOutlined />{" "}
                  {`${
                    !currStatus?.diary?.isArchiveOrUnarchiveRequester
                      ? `${OtherPersonName} has requested you to ${
                          currStatus?.diary?.status?.id === 6
                            ? "archive"
                            : "unarchive"
                        } this journal.`
                      : `Your ${
                          currStatus?.diary?.status?.id === 6
                            ? "Archive"
                            : "Unarchive"
                        } request has been sent to ${OtherPersonName}. Please wait for response.`
                  }
                    `}
                </div>
                {!currStatus?.diary?.isArchiveOrUnarchiveRequester && (
                  <div className="d-flex">
                    <Button
                      size="large"
                      ghost
                      className="mr-2"
                      loading={acceptBtnLoading}
                      onClick={() => {
                        handleDiaryStatus(
                          currStatus?.diary?.status?.id === 6
                            ? "Accepted"
                            : "Archived",
                          currStatus?.diary?.status?.id === 6,
                          2
                        );
                      }}
                    >
                      Decline
                    </Button>
                    <Button
                      size="large"
                      type="primary"
                      loading={declineBtnLoading}
                      onClick={() => {
                        handleDiaryStatus(
                          currStatus?.diary?.status?.id === 6
                            ? "Archived"
                            : "Accepted",
                          currStatus?.diary?.status?.id === 6,
                          1
                        );
                      }}
                    >
                      {currStatus?.diary?.status?.id === 6
                        ? "Archive"
                        : "Unarchive"}
                    </Button>
                  </div>
                )}
              </div>
            ) : (
              <div
                className={`notebook-chat-footer ${
                  seconds !== null && minutes !== null ? "" : "footer-btn-end"
                }`}
              >
                {seconds !== null && minutes !== null && (
                  <div className="nc-footer-text">
                    <InfoCircleOutlined />{" "}
                    {`You can reply to ${OtherPersonName}'s message after
                the time has elapsed.`}
                  </div>
                )}
                {settings?.EnableAI === "1" ? (
                  <Tooltip
                    title={
                      currStatus?.diary?.status?.id === 5
                        ? "Unable to post while journal is archived."
                        : seconds === null || minutes === null
                        ? buttonStatus
                          ? `This topic remains locked unless ${OtherPersonName} replies or ${settings?.LockPeriod} minutes elapse.`
                          : ""
                        : "You can reply to the sender message after the time elapse."
                    }
                  >
                    <Button
                      className={
                        seconds === null &&
                        journalText?.length > 1 &&
                        !buttonStatus
                          ? "resolve-it-ai-btn"
                          : "lock-btn"
                      }
                      size="large"
                      type="primary"
                      icon={
                        seconds === null ? (
                          <i className="icon-magic-wand"></i>
                        ) : (
                          <i className="icon-lock-circle"></i>
                        )
                      }
                      loading={btnLoading && !isEntryModalOpen && !openDrawer}
                      onClick={getResolved}
                      disabled={
                        journalText?.length < 2 ||
                        buttonStatus ||
                        !(currStatus?.diary?.status?.id === 1)
                      }
                    >
                      {seconds === null || minutes === null
                        ? "RESOLVEit"
                        : `${minutes < 10 ? "0" + minutes : minutes}:${
                            seconds < 10 ? "0" + seconds : seconds
                          }`}
                    </Button>
                  </Tooltip>
                ) : (
                  <div className="lock-btn">
                    <Tooltip
                      title={
                        seconds === null || minutes === null
                          ? buttonStatus
                            ? `This topic remains locked unless ${OtherPersonName} replies or ${settings?.LockPeriod} minutes elapse.`
                            : ""
                          : "You can reply to the sender message after the time elapse."
                      }
                    >
                      <Button
                        size="large"
                        type="primary"
                        icon={
                          seconds !== null && (
                            <i className="icon-lock-circle"></i>
                          )
                        }
                        onClick={showDrawer}
                        disabled={journalText?.length < 1 || buttonStatus}
                      >
                        {seconds === null || minutes === null
                          ? "Post Journal Entry"
                          : `${minutes < 10 ? "0" + minutes : minutes}:${
                              seconds < 10 ? "0" + seconds : seconds
                            }`}
                      </Button>
                    </Tooltip>
                  </div>
                )}
              </div>
            )}
          </div>
          {open && (
            <ConfirmationModal
              open={open}
              relationModalDecision={relationModalDecision}
              onClose={onClose}
              btnLoading={btnLoading}
              hours={settings?.GracePeriod}
            />
          )}
          {openDrawer && (
            <AiDrawer
              openDrawer={openDrawer}
              closeChatDrawer={closeChatDrawer}
              resolveResponseRef={resolveResponseRef}
              sendRevised={sendRevised}
              relationModalDecision={relationModalDecision}
              btnLoading={btnLoading}
              editJournalText={editJournalText}
              isEntryModalOpen={isEntryModalOpen}
            />
          )}
          {isEntryModalOpen && (
            <DecisionModal
              isEntryModalOpen={isEntryModalOpen}
              setisEntryModalOpen={setisEntryModalOpen}
              relationshipStatus={relationshipStatus}
              btnLoading={btnLoading}
              postJournal={postJournal}
              onChange={onChange}
            />
          )}
          {unArchiveModalOpener?.flag && (
            <ArchiveRequest isArchiveRequestModalOpen={unArchiveModalOpener} />
          )}{" "}
          {archiveModalOpener?.flag && (
            <ArchiveConversation
              isArchiveConversationModalOpen={archiveModalOpener}
            />
          )}
        </div>
      </>
    </>
  );
}
